class Theme  {
    constructor(tema) {
        this.base_color = tema.base_color;
        this.base_dark_color = tema.base_dark_color;
        this.base_dark_dark_color = tema.base_dark_dark_color;
        this.fight_icon = tema.fight_icon;
        this.friend_icon = tema.friend_icon;
        this.login_text_color = tema.login_text_color;
        this.logo = tema.logo;
        this.play_icon = tema.play_icon;
        this.random_category_icon = tema.random_category_icon;
        this.random_category_icon_list = tema.random_category_icon_list;
        this.screen_home_background_image = tema.screen_home_background_image;
        this.screen_login_background_image = tema.screen_login_background_image;
        this.toolbar_icon = tema.toolbar_icon;
        this.toolbar_icon_aspect_ratio = tema.toolbar_icon_aspect_ratio;
        this.user_icon = tema.user_icon;
        this.color_1 = tema.color_1;
        this.color_2 = tema.color_2;
        this.color_3 = tema.color_3;
        this.color_4 = tema.color_4;
        this.color_5 = tema.color_5;
        this.base_color = tema.color_1;
        this.base_dark_color = tema.color_2;
        this.base_dark_dark_color = tema.color_4;
        this.background = tema.background;
        this.document_animation_points = tema.document_animation_points;
        this.document_sound_points = tema.document_sound_points;
        this.support_color = tema.support_color;
        this.support_name = tema.support_name;
        this.support_avatar = tema.support_avatar;
        this.login_bg_color = tema.login_bg_color;
        this.login_bg_alpha = tema.login_bg_alpha;
        this.login_button_bg_color = tema.login_button_bg_color;
        this.login_button_text_color = tema.login_button_text_color;
        this.login_remember_text_color = tema.login_remember_text_color;
    }

    getLogo() {
        return this.logo;
    };
    getToolbarIcon(){
        return this.toolbar_icon;
    }
}